import { Geometry, View, Element } from '@antv/g2';
import { reduce, get } from '@antv/util';

/**
 * å¨ View ä¸­æ¥æ¾ç¬¬ä¸ä¸ªæå® type ç±»åç geometry
 * @param view
 * @param type
 */
export function findGeometry(view: View, type: string): Geometry {
  return view.geometries.find((g: Geometry) => g.type === type);
}

/**
 * è·å View ç ææ elements
 */
export function getAllElements(view: View): Element[] {
  return reduce(
    view.geometries,
    (r: Element[], geometry: Geometry) => {
      return r.concat(geometry.elements);
    },
    []
  );
}

/**
 * éå½è·å View ç ææ elements, åæ¬ View çå­ View
 */
export function getAllElementsRecursively(view: View): Element[] {
  if (get(view, ['views', 'length'], 0) <= 0) {
    return getAllElements(view);
  }

  return reduce(
    view.views,
    (ele: Element[], subView: View) => {
      return ele.concat(getAllElementsRecursively(subView));
    },
    getAllElements(view)
  );
}

/**
 * éå½è·å View ç ææ geometries, åæ¬ View çå­ View
 */
export function getAllGeometriesRecursively(view: View): Geometry[] {
  if (get(view, ['views', 'length'], 0) <= 0) {
    return view.geometries;
  }

  return reduce(
    view.views,
    (ele: Geometry[], subView: View) => {
      return ele.concat(subView.geometries);
    },
    view.geometries
  );
}
